<template>
  <div class="form-header">
    <div class="form-header-innner">
      <a-button
        class="form-back-btn"
        @click="back"
      >
        {{ $t('message["282"]') }}
      </a-button>
      <div class="form-name">
        <span v-show="isEdit">
          <input
            ref="editInput"
            v-model="name"
            :placeholder="editInputPlace"
            @blur="setEdit"
            @keyup.enter="setEdit"
          >
        </span>
        <span v-show="!isEdit">
          <em>{{ name }}</em>
          <i
            class="iconfont iconicon-test66"
            @click="getEdit"
          />
        </span>
      </div>
      <a-button
        type="primary"
        class="sub-form-btn"
        :loading="isSubmitting"
        @click="handleSave"
      >
        {{ $t('message["21"]') }}
      </a-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    formName: {
      type: String,
      default: ''
    },
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: '',
      isEdit: false
    }
  },
  computed: {
    editInputPlace () {
      return this.$t('message["1574"]')
    }
  },
  watch: {
    formName (val) {
      if (val) {
        this.name = val
      }
    }
  },

  created () {
    // this.form = this.$form.createForm(this)
  },
  mounted () {
    this.name = this.formName
  },

  methods: {
    getEdit () {
      this.isEdit = !this.isEdit
      this.$nextTick(() => {
        this.$refs.editInput.focus()
      })
    },
    setEdit () {
      this.isEdit = false
    },
    handleSave () {
      this.$emit('save', this.name)
    },
    back () {
      this.$emit('back')
    }
  }
}
</script>
<style lang="scss" scoped>
.form-header {
  width: 100%;
  height: 56px;
  background: #fff;
  .form-header-innner {
    height: 32px;
    padding: 12px 0;
    max-width: 1280px;
    margin: 0 auto;
    line-height: 32px;
    position: relative;
    text-align: center;
    .sub-form-btn {
      position: absolute !important;
      right: 0;
      top: 12px;
    }
    .form-back-btn {
      position: absolute;
      left: 0;
      top: 12px;
    }
    .form-name {
      display: inline;
      .iconicon-test66 {
        color: #ebebeb;
        font-size: 18px;
        margin-left: 10px;
        cursor: pointer;
      }
      input {
        border: 0 none;
        width: 234px;
        text-align: center;
        outline: none;
      }
      input::-webkit-input-placeholder {
        /*WebKit browsers*/

        color: #d8d8d8;
      }

      input::-moz-input-placeholder {
        /*Mozilla Firefox*/

        color: #d8d8d8;
      }

      input::-ms-input-placeholder {
        /*Internet Explorer*/

        color: #d8d8d8;
      }
      em {
        font-style: normal;
      }
    }
  }
}
</style>
